import { apiGet, apiPost, unwrapPaginated, unwrapData } from './helpers'

function normalizeCreateResponse(res) {
  const payload = unwrapData(res)
  if (payload && payload.visit) {
    return { visit: payload.visit, pricing: payload.pricing || null }
  }
  return { visit: payload, pricing: null }
}

/**
 * @param {string} lanePath - `weightloss/visits` | `insurance/weightloss/visits`
 */
export function createVisitsApi(lanePath) {
  return {
    listPaginated: (perPage = 10, params = {}, page = 1) =>
      apiGet(`${lanePath}/${Number(perPage) || 10}`, {
        ...params,
        page: Number(page) || 1,
      }).then(unwrapPaginated),
    getById: id => apiGet(`${lanePath}/detail/${id}`).then(unwrapData),
    create: data => apiPost(lanePath, data).then(normalizeCreateResponse),
  }
}

const wlVisitsApi = createVisitsApi('weightloss/visits')
export const wlVisitsInsuranceApi = createVisitsApi('insurance/weightloss/visits')

export default wlVisitsApi
